<template>
  <div>
    <h1 class="section-divider-underline">
      {{ $t("employeeProfile.detail") }}
    </h1>
    <div class="row">
      <div class="col-md-6 tw-space-y-6">
        <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
          >
            {{ $t("employeeProfile.status") }}
          </label>
          <div class="col-md-7">
            <a-select
              v-model.number="model.status_id"
              :class="{ 'is-invalid': errors.has('status_id') }"
              @change="clearOption"
            >
              <!-- <option :value="null" disabled selected style="display: none">
                {{ $t("select") }}
              </option> -->
              <a-select-option
                v-for="(st, index) in formViewDatas.status"
                :key="index"
                :value="st.status_id"
              >
                {{ st.status }}
              </a-select-option>
            </a-select>
            <div class="invalid-feedback" v-if="errors.has('status_id')">
              {{ errors.first("status_id") }}
            </div>
          </div>
        </div>

        <div class="row" v-if="model.status_id == 2 || model.status_id == 3">
          <label
            class="form-label col-form-label col-md-5 tw-text-right"
            :class="{
              required: model.status_id == 2 || model.status_id == 3,
            }"
          >
            {{ $t("employeeProfile.statusEffectiveDate") }}
          </label>
          <div class="col-md-7">
            <a-date-picker
              v-model="model.status_effective_date"
              style="width: 100%"
              placeholder="DD-MM-YYYY"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              @change="onChangeEffectiveDate"
            />
            <div class="text-danger" v-if="errors.has('status_effective_date')">
              {{ errors.first("status_effective_date") }}
            </div>
          </div>
        </div>

        <div class="row" v-if="model.status_id == 2 || model.status_id == 3">
          <label
            class="form-label col-form-label col-md-5 tw-text-right"
            :class="{
              required: model.status_id == 2 || model.status_id == 3,
            }"
          >
            {{ $t("employeeProfile.statusReason") }}
          </label>
          <div class="col-md-7">
            <a-select
              v-model.number="model.status_reason_id"
              :class="{
                'is-invalid': errors.has('status_reason_id'),
              }"
            >
              <a-select-option
                v-for="(st, index) in statusReasons"
                :key="index"
                :value="st.status_reason_id"
              >
                {{ st.reason }}
              </a-select-option>
            </a-select>
            <div class="text-danger" v-if="errors.has('status_reason_id')">
              {{ errors.first("status_reason_id") }}
            </div>
          </div>
        </div>

        <!-- <div class="row">
          <label class="form-label col-form-label col-md-5 tw-text-right">{{
            $t("employeeProfile.line_manager1")
          }}</label>
          <div class="col-md-7">
            <input
              type="number"
              v-model.number="model.line_manager1"
              class="form-control"
              :class="{ 'is-invalid': errors.has('line_manager1') }"
            />
            <div class="invalid-feedback" v-if="errors.has('line_manager1')">
              {{ errors.first("line_manager1") }}
            </div>
          </div>
        </div> -->
        <div class="row">
          <label class="form-label col-form-label col-md-5 tw-text-right">{{
            $t("employeeProfile.address")
          }}</label>
          <div class="col-md-7">
            <textarea
              rows="2"
              v-model="model.address"
              class="form-control"
              :class="{ 'is-invalid': errors.has('address') }"
            ></textarea>
            <div class="invalid-feedback" v-if="errors.has('address')">
              {{ errors.first("address") }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 tw-space-y-6">
        <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
            >{{ $t("employeeProfile.hiredDate") }}</label
          >
          <div class="col-md-7">
            <a-date-picker
              v-model="model.hire_date"
              style="width: 100%"
              placeholder="DD-MM-YYYY"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              @change="onChangeHireDate"
            />
            <div class="text-danger" v-if="errors.has('hire_date')">
              {{ errors.first("hire_date") }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="form-label col-form-label col-md-5 tw-text-right">{{
            $t("employeeProfile.phone")
          }}</label>
          <div class="col-md-7">
            <input
              type="text"
              v-model="model.phone"
              class="form-control"
              :class="{ 'is-invalid': errors.has('phone') }"
            />
            <div class="invalid-feedback" v-if="errors.has('phone')">
              {{ errors.first("phone") }}
            </div>
          </div>
        </div>

        <div class="row">
          <label class="form-label col-form-label col-md-5 tw-text-right">{{
            $t("employeeProfile.email")
          }}</label>
          <div class="col-md-7">
            <input
              type="text"
              v-model="model.email"
              class="form-control"
              :class="{ 'is-invalid': errors.has('email') }"
            />
            <div class="invalid-feedback" v-if="errors.has('email')">
              {{ errors.first("email") }}
            </div>
          </div>
        </div>

        <!-- <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
          >
            {{ $t("employeeProfile.probationEndDate") }}
          </label>
          <div class="col-md-7">
            <a-date-picker
              v-model="model.probation_end_date"
              disabled
              style="width: 100%"
              placeholder="DD-MM-YYYY"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
            />
            <div class="text-danger" v-if="errors.has('probation_end_date')">
              {{ errors.first("probation_end_date") }}
            </div>
          </div>
        </div> -->

        <!-- <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
            >{{ $t("employeeProfile.employeeType") }}</label
          >
          <div class="col-md-7">
            <select
              v-model.number="model.emp_type_id"
              class="form-select"
              :class="{ 'is-invalid': errors.has('emp_type_id') }"
            >
              <option
                v-for="(empType, index) in formViewDatas.employeeType"
                :key="index"
                :value="empType.emp_type_id"
              >
                {{ empType.emp_type_en }} | {{ empType.emp_type_kh }}
              </option>
            </select>
            <div class="invalid-feedback" v-if="errors.has('emp_type_id')">
              {{ errors.first("emp_type_id") }}
            </div>
          </div>
        </div> -->

        <!-- <div class="row">
          <label class="form-label col-form-label col-md-5 tw-text-right">{{
            $t("employeeProfile.line_manager2")
          }}</label>
          <div class="col-md-7">
            <input
              type="number"
              v-model.number="model.line_manager2"
              class="form-control"
              :class="{ 'is-invalid': errors.has('line_manager2') }"
            />
            <div class="invalid-feedback" v-if="errors.has('line_manager2')">
              {{ errors.first("line_manager2") }}
            </div>
          </div>
        </div> -->

        <!-- <div class="row">
          <label class="form-label col-form-label col-md-5 tw-text-right">
            {{ $t("employeeProfile.shift") }}
          </label>
          <div class="col-md-7">
            <select
              v-model.number="model.shift_id"
              class="form-select"
              :class="{ 'is-invalid': errors.has('shift_id') }"
            >
              <option :value="null" disabled selected style="display: none">
                {{ $t("select") }}
              </option>
              <option
                v-for="(shift, index) in formViewDatas.shift"
                :key="index"
                :value="shift.shift_id"
              >
                {{ shift.shift_name }} ({{ shift.shift_type }})
              </option>
            </select>
            <div class="invalid-feedback" v-if="errors.has('shift_id')">
              {{ errors.first("shift_id") }}
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";
import moment from "moment";
import { isEmpty } from "lodash";

export default {
  name: "detail",
  props: ["value", "validation"],
  data() {
    return {
      status: [],
      model: {},
      errors: new Errors(),
      options: null,
    };
  },
  created() {
    this.model = this.value;
  },
  computed: {
    ...mapState("humanResource/employeeProfile", [
      "formViewDatas",
      "edit_data",
    ]),
    statusReasons() {
      if (this.model.status_id) {
        return this.formViewDatas.statusReason.filter(
          (s) => s.status_id == this.model.status_id
        );
      }
      return this.statusReason;
    },
  },
  methods: {
    onChangeHireDate(dateString) {
      this.model.hire_date = dateString;
      this.model.probation_end_date = moment(this.model.hire_date, "DD-MM-YYYY")
        .add(3, "M")
        .format("DD-MM-YYYY");
    },
    onChangeEffectiveDate(dateString) {
      this.model.status_effective_date = dateString;
    },
    clearOption() {
      this.model.status_reason_id = null;
      this.options = null;
    },
  },
  watch: {
    "model.status_id": function (value) {
      if ((value == 2) | (value == 3)) {
        this.model.status_effective_date = !isEmpty(this.edit_data)
          ? this.edit_data.status_effective_date
          : moment().format("DD-MM-YYYY");

        this.model.status_reason_id = !isEmpty(this.edit_data)
          ? this.edit_data.status_reason_id
          : null;
      } else {
        this.model.status_effective_date = "";
      }
    },
    validation: {
      handler() {
        this.errors = new Errors(this.validation.errors);
      },
      deep: true,
    },
  },
};
</script>

<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  /* border-bottom: 1px solid #eee; */
  font-size: 16px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
</style>
